var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Default(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.1875,
    y: 4.68652,
    width: 22.6274,
    height: 22.6274,
    rx: 2,
    fill: "#A7A9BC",
    fillOpacity: 0.52
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 16,
    width: 22.6274,
    height: 22.6274,
    rx: 2,
    transform: "rotate(-45 0.5 16)",
    fill: "#A7A9BC",
    fillOpacity: 0.52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9579 21.1402C16.3233 21.1402 15.7446 21.0235 15.2219 20.7902C14.7086 20.5475 14.2746 20.1975 13.9199 19.7402L14.8159 18.8442C15.0306 19.1708 15.3246 19.4322 15.6979 19.6282C16.0713 19.8148 16.4866 19.9082 16.9439 19.9082C17.3733 19.9082 17.7419 19.8288 18.0499 19.6702C18.3673 19.5022 18.6146 19.2688 18.7919 18.9702C18.9786 18.6715 19.0719 18.3262 19.0719 17.9342C19.0719 17.5328 18.9786 17.1875 18.7919 16.8982C18.6146 16.5995 18.3626 16.3708 18.0359 16.2122C17.7093 16.0535 17.3219 15.9742 16.8739 15.9742C16.7059 15.9742 16.5379 15.9882 16.3699 16.0162C16.2019 16.0348 16.0386 16.0675 15.8799 16.1142L16.4399 15.3582C16.6173 15.2742 16.8086 15.2088 17.0139 15.1622C17.2193 15.1155 17.4246 15.0922 17.6299 15.0922C18.1526 15.0922 18.6193 15.2135 19.0299 15.4562C19.4499 15.6988 19.7813 16.0395 20.0239 16.4782C20.2759 16.9168 20.4019 17.4255 20.4019 18.0042C20.4019 18.6202 20.2526 19.1662 19.9539 19.6422C19.6646 20.1088 19.2633 20.4775 18.7499 20.7482C18.2366 21.0095 17.6393 21.1402 16.9579 21.1402ZM15.8799 16.1142V15.3162L18.7219 12.0822L20.2899 12.0682L17.3639 15.3862L15.8799 16.1142ZM14.3819 12.4602V11.2842H20.2899V12.0682L19.1419 12.4602H14.3819Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Default);
export default __webpack_public_path__ + "static/media/3-default.5daf28d4a4f5c4dad50d022d70c6b3ac.svg";
export { ForwardRef as ReactComponent };